export enum SuperTableAddColumn {
    FREE_COLUMN = 'BALANCE',
    CALCULATION = 'CALCULATION',
}
